{
  "delete_project": "Are you sure you want to delete this project ?",
  "delete_project_description": "This action cannot be undone. This will permanently delete the \"{{name}}\" project, all its files and associated resources.",
  "delete_project_title": "Delete project",
  "project_name_label": "Please type \"{{name}}\" to confirm"
}
